import { linkTo } from '@99designs/routing';
import type { ZendeskLanguage } from '@99designs/routing';
import type { ContestTier, ProductFeature } from '../types';

export const getTierFeatures = (
    tier: ContestTier,
    category: string,
    lang: ZendeskLanguage
): ProductFeature[] => {
    const moneyBackGuaranteeLink = linkTo.supportUrl('204108729', 'articles', lang);

    const features: Record<ContestTier, ProductFeature[]> = {
        bronze: [
            { name: __('Expect ~30 designs'), included: true },
            {
                name: __(
                    "Money back guarantee\n <MoneyBackGuaranteeLink>T&C's apply</MoneyBackGuaranteeLink>"
                ),
                links: {
                    MoneyBackGuaranteeLink: moneyBackGuaranteeLink,
                },
                included: true,
            },
            { name: __('Higher prize money attracts more design concepts'), included: false },
            { name: __('Mid & top level designers only'), included: false },
            { name: __('Dedicated manager'), included: false },
            { name: __('Prioritized support'), included: false },
        ],
        silver: [
            {
                name:
                    category === 'logo-design'
                        ? __('Expect ~60 designs')
                        : __('Expect ~40 designs'),
                included: true,
            },
            {
                name: __(
                    "Money back guarantee\n <MoneyBackGuaranteeLink>T&C's apply</MoneyBackGuaranteeLink>"
                ),
                links: {
                    MoneyBackGuaranteeLink: moneyBackGuaranteeLink,
                },
                included: true,
            },
            { name: __('Higher prize money attracts more design concepts'), included: true },
            { name: __('Mid & top level designers only'), included: false },
            { name: __('Dedicated manager'), included: false },
            { name: __('Prioritized support'), included: false },
        ],
        gold: [
            {
                name:
                    category === 'logo-design'
                        ? __('Expect ~90 designs')
                        : __('Expect ~50 designs'),
                included: true,
            },
            {
                name: __(
                    "Money back guarantee\n <MoneyBackGuaranteeLink>T&C's apply</MoneyBackGuaranteeLink>"
                ),
                links: {
                    MoneyBackGuaranteeLink: moneyBackGuaranteeLink,
                },
                included: true,
            },
            { name: __('Higher prize money attracts more design concepts'), included: true },
            { name: __('Mid & top level designers only'), included: true },
            { name: __('Dedicated manager'), included: false },
            { name: __('Prioritized support'), included: false },
        ],
        platinum: [
            {
                name:
                    category === 'logo-design'
                        ? __('Expect ~60 premium designs')
                        : __('Expect ~40 premium designs'),
                included: true,
            },
            {
                name: __(
                    "Money back guarantee\n <MoneyBackGuaranteeLink>T&C's apply</MoneyBackGuaranteeLink>"
                ),
                links: {
                    MoneyBackGuaranteeLink: moneyBackGuaranteeLink,
                },
                included: true,
            },
            { name: __('Higher prize money attracts more design concepts'), included: true },
            { name: __('Top level designers only'), included: true },
            { name: __('Dedicated manager'), included: true },
            { name: __('Prioritized support'), included: true },
        ],
    };

    return features[tier];
};
